<div class="row m-0">
  <div class="col-md-2 p-0 mobile-hide"></div>
  <div class="col-md-3 col-sm-12 p-0 mobile-hide"></div>
  <div class="col-md-5 col-sm-12 p-0">
    <div class="card chats p-2">
      <div class="mobile-hide">
        <div class="d-flex cursor" (click)="showChat()">
          <span class="material-icons" style="margin-top: -3px">
            keyboard_arrow_up
          </span>
          show
        </div>
      </div>
      <div class="chat-options">
        <div
          class="d-flex ellipsis align-items-center"
          style="width: calc(100% - 110px)"
        >
          <div class="position-relative">
            <img
              class="pe-2"
              [src]="commonService.resource.image.user_icon"
              alt=""
            />
            <span
              class="offline"
              *ngIf="commonService.peerStatus == 'OFFLINE'"
              style="position: absolute; left: 20px; top: -2px"
            >
              <span></span>
            </span>
          </div>
          <div
            class="app-content-body font-14 pt-0"
            style="
              width: calc(100% - 50px);
              text-overflow: ellipsis;
              overflow-x: hidden;
              white-space: nowrap;
            "
          >
            {{ "chat.title" | translate
            }}<span class="fw-bold text-capitalize">{{
              commonService.peerDetails.displayName
            }}</span>
          </div>
        </div>
        <div style="width: 110px">
          <button
            #chatTrigger
            class="secondary-button px-3 font-12 p-0 position-relative"
            style="line-height: 30px; white-space: nowrap"
            (click)="showChat()"
          >
            {{ "chat.backToChat" | translate }}
            <span class="message-count" *ngIf="commonService.unreadMessage">{{
              this.commonService.unreadMessage
            }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-2 mobile-hide"></div>
</div>

<!-- Modal -->
<div
  mdbModal
  #chatModal="mdb-modal"
  id="chat-container"
  class="modal fade show"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="false"
  [config]="{ keyboard: false }"
>
  <div [innerHTML]="commonService.getModalBackgroundImg('#FFF2E7')"></div>
  <div class="row m-0">
    <div class="col-md-2 p-0"></div>
    <div class="col-md-3 col-sm-12 p-0"></div>
    <div class="col-md-5 col-sm-12 p-0">
      <div class="modal-dialog chat-modal-dialog">
        <div class="modal-content">
          <div class="modal-body p-0">
            <div class="">
              <div class="chat-header px-3 py-2">
                <div class="app-heading font-14 cursor" (click)="closeChat()">
                  <span class="material-icons-two-tone font-30"
                    >expand_more</span
                  >
                  hide
                </div>
                <div class="chat-options">
                  <div class="gap-3 d-flex align-items-center chat-peer-info">
                    <img
                      [src]="commonService.resource.image.user_icon"
                      alt=""
                    />
                    <div class="app-content-body font-14 pt-0 chat-peer-name">
                      <span class="fw-bold text-capitalize">{{
                        commonService.peerDetails.displayName
                      }}</span>
                      <span
                        class="online"
                        *ngIf="commonService.peerStatus == 'ONLINE'"
                      >
                        <span></span><span></span>
                      </span>
                      <span
                        class="offline"
                        *ngIf="commonService.peerStatus == 'OFFLINE'"
                      >
                        <span></span>
                      </span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center gap-2 chat-header-actions">
                    <div class="lang-toggle-mobile mobile-show" #langWrapper>
                      <button
                        type="button"
                        class="lang-icon-btn"
                        (click)="toggleLanguage()"
                        aria-label="Change language"
                      >
                        <span class="material-icons-outlined">language</span>
                      </button>
                      <div class="lang-dropdown-mobile" *ngIf="showLanguage">
                        <div
                          class="lang-dropdown-item"
                          *ngFor="let option of availableLanguages()"
                          (click)="selectLanguage(option)"
                        >
                          {{ option }}
                        </div>
                      </div>
                    </div>
                    <button
                      mat-button
                      class="primary-button px-3 text-white bg-black font-12"
                      style="line-height: 19px"
                      (click)="showEndChat()"
                    >
                      {{ "chat.endChat" | translate }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-12 p-0">
                <div
                  class="chat-container"
                  #chat
                  [scrollTop]="chat.scrollHeight"
                >
                  <!-- <div class="begin-text" [innerHTML]="('chat.beginMsg' | translate) + commonService.peerDetails.displayName">
                                    </div> -->
                  <div class="pt-3">
                    <ng-container *ngFor="let date of Object.keys(messageObj)">
                      <div class="begin-text">{{ date }}</div>
                      <ng-container
                        *ngFor="let message of messageObj[date]; let i = index"
                      >
                        <div
                          class="row m-0"
                          *ngIf="!message.userId && !message.isNotMessage"
                        >
                          <div class="col-8 p-0">
                            <span class="p-3 secondary-chat-message">
                              <span>
                                <div
                                  class="fw-bold pb-2"
                                  *ngIf="message.is_resource"
                                >
                                  {{ message.header }}
                                </div>
                                <span
                                  [innerHTML]="
                                    message.messageText
                                      | linky : { className: 'links' }
                                  "
                                ></span>
                                <div
                                  class="pt-1"
                                  *ngIf="message.is_resource && message.link"
                                >
                                  <a
                                    class="links"
                                    [href]="message.link"
                                    [attr.target]="
                                      message.link.startsWith(domainUrl)
                                        ? '_self'
                                        : '_blank'
                                    "
                                    >{{ message.link }}</a
                                  >
                                </div>
                              </span>
                            </span>
                            <span
                              class="msg-timestamp d-flex justify-content-start p-1"
                              >{{ message.time }}</span
                            >
                          </div>
                          <div class="col p-0"></div>
                        </div>
                        <div
                          class="row m-0"
                          *ngIf="message.userId && !message.isNotMessage"
                        >
                          <div class="col-4 p-0"></div>
                          <div class="col-8 p-0 text-end">
                            <span
                              class="p-3 primary-chat-message text-white"
                              [innerHTML]="
                                message.messageText
                                  | linky : { className: 'text-white' }
                              "
                            ></span>
                            <span
                              class="msg-timestamp d-flex justify-content-end p-1"
                              >{{ message.time }}</span
                            >
                          </div>
                        </div>
                        <div
                          class="begin-text d-flex justify-content-center"
                          style="border-radius: 0px"
                          *ngIf="message.isNotMessage"
                        >
                          {{ message.process | translate }}
                          <span *ngIf="message.process == 'chat.beginMsg'">
                            &nbsp;{{ message.user }}</span
                          >
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
            <emoji-mart
              id="emoji-container"
              [showPreview]="false"
              *ngIf="showEmojiPicker"
              [useButton]="true"
              [showSingleCategory]="true"
              [emojiTooltip]="true"
              (emojiSelect)="addEmoji($event)"
            ></emoji-mart>
            <div class="modal-footer border-0 m-0" style="padding: 0px 26px">
              <div
                class="w-100 d-flex justify-content-between gap-3 position-relative"
              >
                <input
                  id="message-input"
                  type="text"
                  class="chat-input mobile-show"
                  [(ngModel)]="message"
                  (keydown.enter)="sendMessage()"
                />
                <textarea
                  id="message-input-desk"
                  class="chat-input mobile-hide"
                  row="4"
                  [(ngModel)]="message"
                  (keydown.enter)="sendMessage()"
                ></textarea>
                <span
                  class="material-icons-outlined emoji-select"
                  (click)="showEmoji()"
                  id="emoji-btn"
                >
                  sentiment_satisfied_alt
                </span>
                <button class="send-btn" (click)="sendMessage()">
                  <span class="material-icons-outlined">north </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-2 p-0"></div>
    </div>
  </div>
</div>

<!-- Modal -->
<div
  mdbModal
  #endChatModal="mdb-modal"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="false"
  [config]="{ keyboard: false, ignoreBackdropClick: true }"
>
  <div [innerHTML]="commonService.getModalBackgroundImg('#FFF2E7')"></div>
  <div class="row m-0">
    <div class="col-md-2 p-0"></div>
    <div class="col-md-3 col-sm-12 p-0"></div>
    <div class="col-md-5 col-sm-12 p-0">
      <div class="modal-dialog chat-modal-dialog">
        <div class="modal-content">
          <div class="modal-body p-0 chat-header d-flex flex-column">
            <div class="h-100">
              <img
                class="bg-line mobile-show position-fixed"
                [src]="commonService.resource.image.modal_bg_line"
                alt=""
                *ngIf="!isChatEnded"
              />
              <div
                class="row m-0"
                style="height: calc(100% - 10px); overflow: hidden auto"
              >
                <div
                  class="p-0"
                  [ngClass]="{
                    'col-md-2': !isChatEnded,
                    'col-md-1': isChatEnded
                  }"
                ></div>
                <div
                  class="col-sm-12 col-md-8 pe-0 d-flex align-items-end justify-content-center"
                  *ngIf="!isChatEnded"
                >
                  <div class="position-absolute" style="bottom: 25px">
                    <div class="menu-container">
                      <div class="text-center">
                        <div
                          class="menu-header-content mb-3"
                          [innerHTML]="'endChat.title' | translate"
                        ></div>
                        <div class="app-sub-content mb-3">
                          <span
                            [innerHTML]="'endChat.content' | translate"
                          ></span>
                        </div>
                      </div>
                    </div>
                    <div>
                      <button
                        mat-button
                        class="primary-button w-100 bg-white mb-3"
                        (click)="endChatModal.hide()"
                      >
                        {{ "endChat.secondaryBtn" | translate }}
                      </button>
                      <button
                        mat-button
                        class="primary-button w-100 text-white bg-black"
                        (click)="endChat()"
                      >
                        {{ "endChat.primaryBtn" | translate }}
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-10 p-0" *ngIf="isChatEnded">
                  <div
                    [ngClass]="{
                      'content-container': !isChatEnded,
                      'm-3 p-3 mb-0 pb-0': isChatEnded
                    }"
                  >
                    <span
                      *ngIf="isChatEndedByPeer"
                      class="peer-end-chat"
                      [innerHTML]="'feedback.endByPeer' | translate"
                    ></span>
                    <div
                      class="app-heading d-inline"
                      [innerHTML]="'feedback.title' | translate"
                    ></div>
                    <div class="user-details-card-container mt-5 mx-0">
                      <img
                        class="user-card-vector"
                        [src]="commonService.resource.image.user_vector_border"
                        alt=""
                      />
                      <div class="user-details-content">
                        <div class="subText">
                          {{ "feedback.subText1" | translate }}
                        </div>
                        <div class="rating-list my-3"
                          [ngClass]="{ 'rating-invalid': isApiTriggered && currentFeedback === undefined }">
                          <div
                            class="rating-item"
                            [ngClass]="{ active: currentFeedback == 0 }"
                            (click)="setFeedback(0)"
                          >
                            <img
                              [src]="
                                currentFeedback == 0
                                  ? commonService.resource.image.feedback.rating1_active
                                  : isApiTriggered && currentFeedback == undefined
                                  ? commonService.resource.image.feedback.rating1_invalid
                                  : commonService.resource.image.feedback.rating1
                              "
                              class="rating-img"
                              alt=""
                            />
                            <span class="rating-label">{{ "feedback.feedback1" | translate }}</span>
                          </div>
                          <div
                            class="rating-item"
                            [ngClass]="{ active: currentFeedback == 1 }"
                            (click)="setFeedback(1)"
                          >
                            <img
                              [src]="
                                currentFeedback == 1
                                  ? commonService.resource.image.feedback.rating2_active
                                  : isApiTriggered && currentFeedback == undefined
                                  ? commonService.resource.image.feedback.rating2_invalid
                                  : commonService.resource.image.feedback.rating2
                              "
                              class="rating-img"
                              alt=""
                            />
                            <span class="rating-label">{{ "feedback.feedback2" | translate }}</span>
                          </div>
                          <div
                            class="rating-item"
                            [ngClass]="{ active: currentFeedback == 2 }"
                            (click)="setFeedback(2)"
                          >
                            <img
                              [src]="
                                currentFeedback == 2
                                  ? commonService.resource.image.feedback.rating3_active
                                  : isApiTriggered && currentFeedback == undefined
                                  ? commonService.resource.image.feedback.rating3_invalid
                                  : commonService.resource.image.feedback.rating3
                              "
                              class="rating-img"
                              alt=""
                            />
                            <span class="rating-label">{{ "feedback.feedback3" | translate }}</span>
                          </div>
                          <div
                            class="rating-item"
                            [ngClass]="{ active: currentFeedback == 3 }"
                            (click)="setFeedback(3)"
                          >
                            <img
                              [src]="
                                currentFeedback == 3
                                  ? commonService.resource.image.feedback.rating4_active
                                  : isApiTriggered && currentFeedback == undefined
                                  ? commonService.resource.image.feedback.rating4_invalid
                                  : commonService.resource.image.feedback.rating4
                              "
                              class="rating-img"
                              alt=""
                            />
                            <span class="rating-label">{{ "feedback.feedback4" | translate }}</span>
                          </div>
                        </div>
                        <div class="subText">
                          {{ "feedback.subText2" | translate }}
                        </div>
                        <textarea
                          class="mt-2 feedback-textarea app-content-body"
                          [(ngModel)]="feedbackExperience"
                          placeholder="Share your thoughts..."
                        ></textarea>
                      </div>
                    </div>
                    <button
                      mat-button
                      class="primary-button w-100"
                      (click)="sendFeedBack()"
                      data-bs-dismiss="modal"
                    >
                      {{ "feedback.submitBtn" | translate }}
                    </button>
                  </div>
                </div>
                <div class="p-0 mobile-hide col-md-1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-2 p-0"></div>
    </div>
  </div>
</div>
